export default "__VITE_ASSET__7_oVMZkb__"